export class Init {
    readonly type = 'INIT';

    constructor() {}
}

export type StepsEvent = Init;
